import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-totop',
  templateUrl: './totop.component.html',
  styleUrls: ['./totop.component.sass']
})
export class TotopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
